import React from "react";
import "./About.css";
import mypic from "../../assets/imgs/mypic.jpeg";

function About() {
  return (
    <section id="about-page">
      <div className="back">
        <div className="resume">
          <a
            href="http://3.14.14.50/share/71c20a3a-d1cf-4d14-8eaf-a2632d3fdfd0/file"
            target="_blank"
          >
            Resume
          </a>
          <div></div>
          <div></div>
        </div>
        <article>
          <div>
            <img src={mypic} />
            <h1>About me</h1>
            <p>
              Hi there My name is Tielin Li, 19-year-old, I studied software in
              college, and now I am a full-stack web developer with knowledge of
              C#, Reactjs, Git etc.
            </p>
          </div>
          <p>
            I am from a beautiful small town called{" "}
            <a
              href="https://en.wikipedia.org/wiki/Yongtai_County"
              target="_blank"
            >
              yongtai
            </a>
            &nbsp; in China, and I came to Winnipeg city when I was 16. I
            graduated from high school here and then studied software in MITT
            college. The reason I choose software is ever since I was a kid, I
            have been interested in computers, I feel that from the screen, I
            can explore everything!
          </p>
          <h2>The first time I getting touch with coding</h2>
          <p>
            The first time I experienced the programming field was in grade 6,
            Minecraft was the top trending game at that time. In the early
            mobile version of this game, you can use Javascript to do some mods
            to make the game more fun. I was interested in that, so I tried to
            learnt programming for the first time.
          </p>
          <h2>My hobbies</h2>
          <p>
            In my spare time, I enjoy playing video games, playing guitar,
            reading novels, I also like to hang out with friends. My favourite
            sport is the pool game, the billiards balls colliding sound makes me
            relax.
          </p>
        </article>
      </div>
    </section>
  );
}

export default About;
